<template>
  <div class="pupils">
    <router-view></router-view>
    <top-nav :list="topList"></top-nav>
  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';
  import topNav from 'components/topnav/TopNav'
  import Vue from 'vue';
  export default{
    data(){
      return {
        topList: [
          {
            name: '自有生源',
            to: '/console/pupils',

          }
        ],
      }
    },
    components: {
      topNav,
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .pupils
    width:100%
    height:100%
    background: #f2f2f2
</style>



// WEBPACK FOOTER //
// src/page/pupils/Pupils.vue